
/**
 * 删除所有的 sessionStorage 数据
 */
export function removeAllSession(): void {
    try {
        sessionStorage.clear();
    } catch (error) {
        console.error(`删除所有的 sessionStorage 失败: ${error}`);
    }
}

export function getPermiss(): any[] {
    try {
        const permiss = sessionStorage.getItem("permiss");
        if (permiss === null) {
            return [];
        }
        return JSON.parse(permiss);
    } catch (error) {
        console.error(`解析 permiss 数据失败: ${error}`);
        return [];
    }
}